/* eslint-disable max-lines */
import { ISaveListData } from './../OYFilterBar/components/OYFilterBarSaveList/const';
import { EEventType } from './../../enums/EEventType';
import { IDataType, IValueData } from './../../types/data';
import { EFilterEventName } from './enum';
import './index.less';
import template from './index.art';
import loadingTemplate from './loading.art';
import textTemplate from './text.art';
import errorTemplate from './error.art';
import { IOYFilterProps, IOYFilterState, filterData, IParams, IPropsPrams, getFilterParamMap, isSameObject, getFlatStringValueFilterParams, inputTypes } from './const';
import OY from '../../types/OY';
import { dateFormat, isArray, isObject, mergeDeep, omit } from '../../utils';
import styles from './index.module.less';
import { EFilterType } from '../../enums/EFilterType';
import { jeact } from '../../decorators/jeact';
import OYFilterBar from '../OYFilterBar';
import { jointUrl, paseQuery } from '../OYTool/url';
import OYTool from '../OYTool';
import { EFilterBarEvent, IOYFilterBarTag } from '../OYFilterBar/const';

@jeact()
export default class OYFilter extends OY<IOYFilterProps, IOYFilterState> {
  static displayName = 'OYFilter';

  static defaultProps: Partial<IOYFilterProps> = {
    width: '100%',
    showItems: 9,
    titleWidth: 88,
    value: {},  //点击筛选条件保存到value
    data: {},   //接口返回数据
    loading: false,
    location: true,

    fastQueryList: [],  //已保存列表
    onFeedbackClick() { }
  };

  state: IOYFilterState = {
    keywordAnalyseResult: '',
    keywordAnalyseResultTags: [],
    params: getFilterParamMap(),  //筛选条件集合
    keyTypeMap: {},
    showItems: 8,
    showError: false,
    expand: false,
    errorText: '',
    errorImg: '',
    serviceTooltips: {}  //服务行浮窗
  };

  $node = {
    tr: $(),
    footer: $()
  }

  filterBar!: OYFilterBar;  //OYFilterBar实例

  removeLocationKeys: string[] = []; // 需要移除的urlkey

  keywordAnalyseTitle: any = {
    product: "品种",
    shopSign: "牌号",
    surface: "表面处理",
    warehouse: "仓库",
    manufacture: "产地",
    storeCity: "存放地",
    provider: "商家",
    color: "颜色",
    coatingType: "镀层种类",
    surfaceDispose: "表面处理",
    thickDriverImpl: "厚度",
    widthDriverImpl: "宽度",
    diameterDriverImpl: "直径",
    lengthDriverImpl: "长度",
    floatOnlyDriverImpl: "厚度"
  }
  keywordAnalyseTitleSpecial: any = {
    thickStartDriverImpl: "厚度:大于",
    thickEndDriverImpl: "厚度:小于",
    widthStartDriverImpl: "宽度:大于",
    widthEndDriverImpl: "宽度:大于",
    diameterStartDriverImpl: "直径:大于",
    diameterEndDriverImpl: "直径:小于",
    lengthEndDriverImpl: "长度:小于",
    lengthStartDriverImpl: "长度:大于"
  }

  errorCallback: any = null;

  

  tooltipInstance: any = {}

  getDerivedStateFromProps(props: IOYFilterProps, state: IOYFilterState) {
    const { data, value } = props;
    let params = state.params;
    let tooltips = this.getTooltipFromService(props);
    if (!data || $.isEmptyObject(data)) {
      if (value) {
        params = this._convertValue2Param(value, state.params)
      }
      return { ...state, params ,serviceTooltips: tooltips };
    }
    if (
      !this.props ||
      (this.props.data !== data || this.props.value !== value)
    ) {
      const keywordAnalyseResult = data.keywordAnalyseResult?.value || '';
      const keywordAnalyseResultTags = this.setKeywordAnalyseResultTags(keywordAnalyseResult)
      const omitData = omit(data, ['keywordAnalyseResult']);

      props.data = this.mergePropData2(omitData, filterData)// mergeDeep<{ [i: string]: IDataType }>(omitData, filterData);

      const keyTypeMap = this._getKeyTypeMap(omitData);
      params = this._convertValue2Param(value, this._exactParamsFromData(omitData));
      tooltips = this.getTooltipFromService(props)
      return {
        ...state,
        params,
        keyTypeMap,
        keywordAnalyseResult,
        keywordAnalyseResultTags,
        serviceTooltips: tooltips
      }
    }
    // console.log(this.state.params, props.data, this.state.keyTypeMap)
    return { ...state, params , serviceTooltips: tooltips};
  }

  render() {
    const renderData = { props: this.props, state: this.state, styles };
    // 渲染error
    if (this.state.showError) {
      return errorTemplate(renderData);
    }
    // 渲染loading
    if (this.props.loading) {
      return loadingTemplate(renderData)
    }
    // 渲染无数据
    if (!this.props.data) {
      return textTemplate(renderData)
    }
    this.$el = $(template(renderData));

    this.renderIndustryComponet();
    this.renderInput();
    this.renderDropdownInput();
    this.renderDropdownInputRange();
    this.renderCheckbox();
    this.renderSelect();
    this.renderOYProductType();
    this.renderRadioCheckbox();
    this.renderOYSpecification();
    this.renderOYBalanceWeight();
    this.renderOYFlag();
    this.renderOYProductProp();
    this.renderCategoryTab();
    this.renderOrderBar();
    this.renderOYDatePicker();
    this.renderButton();
  }

  componentAfterRender() {
    this.setLocation();

    // 设置tooltip
    Object.keys(this.tooltipInstance).forEach(key => {
      this.tooltipInstance[key].tooltip('destroy')
    })
    this.tooltipInstance = {};
    Object.keys(this.state.serviceTooltips).forEach(key => {
      const tt = this.$el.find(`[data-key="${key}"]`).tooltip({
        title: this.state.serviceTooltips[key],
        container: document.body
      })
      this.tooltipInstance[key] = tt;
    })
  }

  componentDidUpdate() {
    this._renderCollapseButton();
    this._renderConfirmButton();

    // 如果该行不存在.则直接删除该行dom
    this.$node.tr.each((_idx, ele) => {
      const $ele = $(ele);
      const trInfo  = this.props.data[$ele.attr('id')]&&this.props.data[$ele.attr('id')].info
      const trType  = this.props.data[$ele.attr('id')]&&this.props.data[$ele.attr('id')].type
      if ($ele.outerHeight() < 30||(trType&&trType===6&&(!trInfo||!trInfo.length))) {
        $ele.remove();
      }
    });
    this.$node.tr = this.$el.find('tr.filter-tr');
    setTimeout(() => {
      this.setShowItems();
    })
  }

  setNode() {
    this.$node = {
      tr: this.$el.find('tr.filter-tr'),
      footer: this.$el.find(`.${styles.footer}`)
    }
  }

  // 渲染爆炸图
  renderIndustryComponet() {
    const { industryComponet, industryComponetStaticPath, industryComponetValue } = this.props;
    if (industryComponet && industryComponet.length) {
      this.$el.find('oy-industry-componet').OYIndustryComponet({
        baseUrl: industryComponetStaticPath,
        value: industryComponetValue,
        data: industryComponet,
        onClick: (name: string, value: string) => {
          this.eventEmitter.emit(EEventType.onIndustryComponetClick, name, value)
        }
      })
    }
  }

  /**
   * 渲染品种
   */
  renderOYProductType() {
    const key = 'productType';
    const data = this.props.data[key];
    const { params } = this.state;
    if (data && data.info) {
      this.$el.find('product-type').OYProductType({
        value: params[key],
        info: data.info,
        onChange: (value: string[]) => {
          this.setDataAndEmitChange(value, [key]);
          setTimeout(() => {
            this._triggerSearch();
          });
        }
      })
    }
  }

  // 渲染规格
  renderOYSpecification() {
    const key = 'spec';
    const data = this.props.data[key];
    const { params } = this.state;
    if (data && data.name) {
      this.$el.find('specification').OYSpecification({
        ...data,
        value: params[key],
        onChange: (value: string[], innerKey: string) => {
          this.setDataAndEmitChange(value, [key, innerKey]);
        }
        // onSearch: () => {
        //   this._triggerSearch();
        // }
      })
    }
  }

  // 渲染件重
  renderOYBalanceWeight() {
    const key = 'balanceWeight';
    const data = this.props.data[key];
    const { params } = this.state;
    if (data) {
      this.$el.find('balance-weight').OYBalanceWeight({
        ...data,
        value: (params[key] as string[])[0],
        onChange: (value: string) => {
          this.setDataAndEmitChange([value], [key]);
        },
        onSearch: () => {
          this._triggerSearch();
        }
      })
    }
  }

  // 渲染验证
  renderOYFlag() {
    const key = 'flag';
    const { params } = this.state;
    const data = this.props.data[key];
    if (data) {
      this.$el.find(key).OYFlag({
        ...data,
        value: params[key],
        onChange: (value: string[], ckey: string) => {
          this.setDataAndEmitChange(value, [key, ckey]);
        },
        onSearch: () => {
          this._triggerSearch();
        }
      })
    }
  }

  renderOYProductProp() {
    const { params } = this.state;
    const key = 'productProp';
    const data = this.props.data[key];

    if (data && data.info) {
      this.$el.find('product-prop').OYProductProp({
        ...data,
        value: params[key],
        onChange: (value: string[], ckey: string) => {
          this.setDataAndEmitChange(value, [key, ckey]);
          this._triggerSearch();
        }
      })
    }
  }

  renderCheckbox() {
    this.$el.find('oy-checkbox').each((_index, element) => {
      const $element = $(element);
      const keys = $element.data('key').split(',');
      const { data, value } = this._getDataAndValueByKey(keys)
      $element.OYCheckbox({
        ...data,
        value,
        beforeChange: (cvalue: string) => {
          if (this.props.beforeChange) {
            return this.props.beforeChange(cvalue, keys);
          }
          return true;
        },
        onChange: (cvalue: string[]) => {
          this.setDataAndEmitChange(cvalue, keys);
          this._triggerSearch();
        }
      })
    })
  }

  renderInput() {
    this.$el.find('oy-input').each((_index, element) => {
      const $element = $(element);
      const keys = $element.data('key').split(',');
      const { data, value } = this._getDataAndValueByKey(keys)
      $element.OYInput({
        ...data,
        value: value[0],
        onChange: (cvalue: string) => {
          this.setDataAndEmitChange([cvalue], keys);
          this._triggerSearch();
        }
      })
    })
  }

  renderDropdownInput() {
    this.$el.find('oy-dropdown-input').each((_index, element) => {
      const $element = $(element);
      const keys = $element.data('key').split(',');
      const { data, value } = this._getDataAndValueByKey(keys)
      $element.OYDropdownInput({
        ...data,
        value: value[0],
        onChange: (cvalue: string) => {
          this.setDataAndEmitChange([cvalue], keys);
          this._triggerSearch();
        }
      })
    })
  }

  renderDropdownInputRange() {
    this.$el.find('oy-dropdown-input-range').each((_index, element) => {
      const $element = $(element);
      const keys = $element.data('key').split(',');
      const { data, value } = this._getDataAndValueByKey(keys)
      $element.OYDropdownInputRange({
        ...data,
        value: value[0],
        onChange: (cvalue: string[]) => {
          this.setDataAndEmitChange(cvalue, keys);
          this._triggerSearch();
        }
      })
    })
  }

  renderRadioCheckbox() {
    this.$el.find('oy-radio-checkbox').each((_index, element) => {
      const $element = $(element);
      const keys = $element.data('key').split(',');
      const { data, value } = this._getDataAndValueByKey(keys);
      const propsHeightSpec = this.props.value?.other?.heightSpec;
      let heightSpec
      if (keys.indexOf('spec1') !== -1 && propsHeightSpec) {
        heightSpec = propsHeightSpec?propsHeightSpec.indexOf(',')>0?propsHeightSpec.split(','):[]:[];
      }
      $element.OYRadioCheckbox({
        ...data,
        value,
        heightSpec,
        onChange: (cvalue: string[]) => {
          this.setDataAndEmitChange(cvalue, keys);
          this._triggerSearch();
        },
        onRangeInputConfirm: (cvalue: string[]) => {
          this.setDataAndEmitChange(cvalue, ['other', 'heightSpec']);
          this._triggerSearch();
        }
      })
    })
  }

  renderSelect() {
    this.$el.find('oy-select').each((_index, element) => {
      const $element = $(element);
      const keys = $element.data('key').split(',');
      const { data, value } = this._getDataAndValueByKey(keys)
      $element.OYSelect({
        info: data.info,
        value: value[0],
        simple: true,
        placeholder: data.name,
        onChange: (cvalue: string) => {
          this.setDataAndEmitChange([cvalue], keys);
          this._triggerSearch();
        }
      })
    })
  }

  renderCategoryTab() {
    this.$el.find('oy-category-tab').each((_index, element) => {
      const $element = $(element);
      const keys = $element.data('key').split(',');
      const { data, value } = this._getDataAndValueByKey(keys);

      let shopSignLike = '';
      if (keys.indexOf('shopSign') !== -1 && this.props.value?.other?.shopSignLike) {
        shopSignLike = this.props.value?.other?.shopSignLike;
        shopSignLike = isArray(shopSignLike) ? shopSignLike[0] : shopSignLike;
      }

      $element.OYCategoryTab({
        ...data,
        value,
        shopSignLike,
        onChange: (cvalue: string[]) => {
          this.setDataAndEmitChange(cvalue, keys)
        },
        onInputChange: (cvalue: string) => {
          this.setDataAndEmitChange([cvalue], ['other', 'shopSignLike']);
          this._triggerSearch();
        },
        onSearch: () => {
          this._triggerSearch();
        }
      })
    })
  }

  renderOrderBar() {
    const {
      data,
      showFastQueryList,
      fastQueryList,
      operations,
      renderRight,
      activedSaveName,
      showSaveBtnTips,
      canBeSub,
      showNewBtn
    } = this.props;

    let tags = this.props.tags || [];
    tags = tags.concat(this.state.keywordAnalyseResultTags, this.getInnerTags())
    let channel = null;
    if (data.channel && data.channel.info && data.channel.info.length) {
      channel = data.channel.info;
    }

    //OYFilterBar  参数
    const barProps = {
      activedSaveName,
      channelValue: this.state.params.channel as any,
      channel,
      tags,
      showFastQueryList,
      fastQueryList,
      operations,
      renderRight,
      showSaveBtnTips,
      canBeSub,
      showNewBtn
    }

    this.filterBar = this.$el.find('oy-order-bar').OYFilterBar(barProps)
    // 事件绑定
    this.filterBar.addEvent({
      onFeedbackClick: () => {
        this.eventEmitter.emit(EFilterBarEvent.onFeedbackClick)
      },
      onSaveListClick: (...args: any[]) => {
        this.eventEmitter.emit(EFilterBarEvent.onSaveListClick, ...args)
      },
      onSaveIconClick: () => {
        this.$emit(EFilterBarEvent.onSaveIconClick);
      },
      onSaveListDelete: (...args: any[]) => {
        this.eventEmitter.emit(EFilterBarEvent.onSaveListDelete, ...args)
      },
      onSave: (saveTags: IOYFilterBarTag[]) => {
        this.eventEmitter.emit(EEventType.onSave, saveTags)
      },
      onRemove: (da: IOYFilterBarTag, index: number) => {
        const { global, key, value, parent } = da
        // this.removeLocationKeys.push(da.key)
        if (global === 0) {
          this.removeParamsByTagInfo(key, value);
        } else if (parent === 'keywordAnalyseResult') {
          this.removeKeywordAnalyseResultTags(key, value)
        } else if (global === 1) {
          // 如果有全局的tag。则需要将对应的url key移除
          const removeKey = key.replace(/_([a-z])/g, (_m, p1) => p1.toUpperCase())
          this.removeLocationKeys.push(removeKey)
        }
        this.eventEmitter.emit(EFilterBarEvent.onTagRemove, da, index)
      },
      onReset: () => {
        this.removeLocationKeys = this.filterBar
          .getTags()
          .filter(tag => tag.global === 1)
          .map(tag => tag.key.replace(/_([a-z])/g, (_m, p1) => p1.toUpperCase()));
        // 有分词需要清除keySearch
        if (this.state.keywordAnalyseResult) {
          this.removeLocationKeys.push('keySearch')
        }

        // const { params } = this.state;
        // params.channel && this.removeLocationKeys.push('channel')
        this.eventEmitter.emit(EFilterBarEvent.onTagReset)
      },
      onChannelClick: (channelData: IValueData, index: number) => {
        const { params } = this.state;
        params.channel = [channelData.value];
        this.setState({ params });
        this.eventEmitter.emit(EFilterBarEvent.onChannelClick, channelData, index);
      },
      //关闭保存气泡提示
      onCloseSaveTips: ()=>{
        this.eventEmitter.emit(EFilterBarEvent.onCloseSaveTips);
      }
    })
  }

  renderOYDatePicker() {
    const { data } = this.props;
    this.$el.find('oy-datepicker').each((_idx, ele) => {
      const $element = $(ele);
      const keys: string[] = $element.data('key').split(',');

      const da = keys.reduce((pre, key) => {
        return pre.info ? (pre.info as any)[key] : pre[key]
      }, data)

      const value = keys.reduce((pre, cur) => pre[cur] as IParams, this.state.params)
      $element.data('key').split('')
      $(ele).OYDatePicker({
        ...da,
        value,
        onChange: (values: string[]) => {
          // console.log(values)
          // console.log(values.map(va => va ? new Date(parseInt(va)) : ''))
          this.setDataAndEmitChange(values, keys);
        }
      })
    })
  }

  renderButton() {
    this.$el.find('oy-button').each((_index, element) => {
      const $element = $(element);

      $element.OYButton({
        onClick() {
          const $wrapper = this.$el.prev() as JQuery;
          $wrapper.toggleClass(styles.isCollapse);

          let { icon, text } = this.props;
          text = text === '更多' ? '收起' : '更多';
          icon = text === '更多' ? 'down' : 'up'

          this.setProp({ icon, text })
        }
      })
    })
  }

  setShowItems() {
    const { showItems, data } = this.props;
    const { expand } = this.state;
    // const len = Object.keys(data).filter(key => !['other', 'channel'].includes(key)).length;
    if (typeof showItems === 'boolean') {
      if (!showItems && !expand) {
        this.$node.tr.hide()
      }
      this.$node.footer.remove();
    } else if (showItems! >= this.$node.tr.length) {
      this.$node.footer.remove();
    } else {
      if (!expand) {
        this.$node.tr.each((index, tr) => {
          if (index + 1 > showItems!) {
            $(tr).hide();
          }
        })
      }
    }
  }

  /**
   * 设置快捷保存数据。请确保filterBar存在。否则请使用fastQueryList props
   * @param data 数据
   * @exports
   */
  setFastQueryList(data: ISaveListData[]) {
    if (this.filterBar) {
      this.props.showFastQueryList = true;
      this.props.fastQueryList = data; // 同步父级数据
      this.filterBar.setSaveList(data); // 最小化渲染
    }
  }

  /**
   * 显示错误文本
   *
   * @param {{ text: string, img: string }} { text, img } 文本和图片
   * @param {() => {}} [cb] 点击重新加载后执行的回调函数
   * @exports
   */
  showError({ text, img }: { text: string, img: string }, cb?: () => {}) {
    this.setState({
      showError: true,
      errorText: text || '',
      errorImg: img || ''
    })
    this.errorCallback = cb || null;
  }

  /**
   * 修改数量重量
   * @param count 数量
   * @param totalWeight 重量
   * @exports
   */
  changeNumber(count?: number, weight = 0) {
    let totalWeight = typeof weight !== 'number' ? Number(weight) : weight;
    if (isNaN(totalWeight)) {
      totalWeight = 0;
    }
    if (this.filterBar) {
      this.filterBar.setProp({
        count,
        totalWeight: totalWeight.toFixed(3)
      })
    }
  }

  /**
   * 获取筛选栏中所有的tag
   * @exports
   */
  getTags() {
    return this.filterBar.getTags();
  }

  /**
   * 获取筛选参数
   * @exports
   */
  getParams() {
    const params = this.getStateParams(true);
    if (this.state.keywordAnalyseResult) {
      return { ...params, keywordAnalyseResult: this.state.keywordAnalyseResult }
    }
    return params;
  }

  /**
   * 将state.params转换成查询参数
   * @param ignoreEmpty 是否忽略空值。默认false
   * @param params 数据。函数内部递归。初始为state.params
   */
  getStateParams(ignoreEmpty = false, params = this.state.params) {
    const param: any = {};
    Object.keys(params).forEach(key => {
      const element = params[key];
      if (this._isArray(element)) {
        const isEmpty = this._isEmptyArrary(element);
        if (ignoreEmpty && isEmpty) {
          return;
        }
        param[key] = isEmpty ? '' : element.join(',')
      } else {
        const result = this.getStateParams(ignoreEmpty, element);
        if (ignoreEmpty && $.isEmptyObject(result)) {
          return;
        }
        param[key] = result;
      }
    })

    return param;
  }

  /**
   * 通过params生成tags信息
   * @param propsData  筛选器数据
   * @param params  已选择筛选内容
   */
  getInnerTags(propsData = this.props.data, params: IParams = this.state.params, parent: string | null = null) {
    const tags: any[] = [];

    Object.keys(params).forEach(key => {
      const param = params[key]; // string string[] object
      const propData = propsData[key];
      if (!propData || key === 'channel') {
        return;
      }
      const { renderFilterTag, renderFilterTagTitle } = propData

      if (this._isArray(param)) {
        if (this._isEmptyArrary(param)) {
          return;
        }
        //inputTypes 4，5，14，15，16
        if (inputTypes.includes(propData.type)) {
          let tabTitleValue = '';
          if (propData.type === EFilterType.DatePicker) {
            const [start, end] = param.map(pa => pa ? dateFormat(new Date(Number(pa))) : '')

            if (start && end) {
              tabTitleValue = start + '至' + end;
            } else if (start && !end) {
              tabTitleValue = '晚于' + start
            } else if (!start && end) {
              tabTitleValue = '早于' + end
            }
          } else if (renderFilterTag) {
            tabTitleValue = renderFilterTag(param);
          } else {
            tabTitleValue = param.join('-');
          }

          let title = propData.name || '';
          if (renderFilterTagTitle) {
            title = renderFilterTagTitle(title);
          }
          if (title) {
            title += ':';
          }
          title += tabTitleValue;
          tags.push({ title, key, value: param.join(','), parent, global: 0 })
        } else {
          param.forEach(pa => {
            const result = this._getValue(pa, propData.info);
            const value = result ? result.value : pa;
            // 如果找不到值.并且nameCode中无法匹配中值.则忽略这个参数
            // FIXED: 件重有input框输入.所以需要额外判断处理
            if (!result && !(propData.nameCode || {})[pa] && key !== 'balanceWeight') {
              return;
            }

            let title = propData.name || '';
            if (renderFilterTagTitle) {
              title = renderFilterTagTitle(title);
            }
            if (title) {
              title += ':';
            }

            if (renderFilterTag) {
              title += renderFilterTag(pa, result);
            } else if (result) {
              title += result.name
            } else if (propData.nameCode) {
              title += propData.nameCode[pa] || pa;
            } else {
              title += pa;
            }
            tags.push({ title, key, value, parent, global: 0 })
          })
        }
      } else if (isObject(param)) {
        tags.push(...this.getInnerTags(propData.info, param, key))
      }
    })

    return tags
  }

  protected bindToggleCondition() {
    this.$el.find(`.${styles.footer} .content-text`).off('click').on('click', (event: Event) => {
      const $element = $(event.currentTarget!);
      const $img = $element.find('i');
      const noExpand = $img.hasClass(styles.down);
      if (noExpand) {
        $element.find('span').text('收起更多条件')
        this.$node.tr.show()
        this._setState({ expand: true })
      } else {
        this.$node.tr.each((index, tr) => {
          if (index + 1 > this.props.showItems!) {
            $(tr).hide();
          }
        })
        this._setState({ expand: false })
        $element.find('span').text('展开更多条件')
      }
      this.eventEmitter.emit(EEventType.onToogle, noExpand) // 提供当前是否展开
      $img.toggleClass(styles.down);
    })
  }

  protected bindErrorReload() {
    this.$el.find(`.${styles.error_text_reload}`).click(() => {
      this._setState({ showError: false, errorImg: '', errorText: '' });
      // 如果回调存在执行回调
      if (this.errorCallback) {
        this.errorCallback();
        this.errorCallback = null;
      }
      this.eventEmitter.emit(EEventType.onErrorReload)
    })
  }

  /** 给表格列渲染更多按钮 */
  private _renderCollapseButton() {
    Object.keys(this.props.data).forEach(key => {
      const item = this.props.data[key];
      if (item.collapse && ![EFilterType.RadioWithCheckbox].includes(item.type)) {
        // console.log(this.$el.find(`#${key} .${styles.tdWrapper}`).height())
        const $tdWrapper = this.$el.find(`#${key} .${styles.tdWrapper}`);
        if ($tdWrapper.height() > 30) {
          const $button = $('<div/>');
          const button = $button.OYButton({
            text: '更多',
            type: 'ghost',
            size: 'small',
            icon: 'down',
            attrs: {
              class: styles.collapseButton
            },
            onClick() {
              const $wrapper = (this.$el as JQuery).parent();
              $wrapper.toggleClass(styles.isCollapse);

              let { icon, text } = this.props;
              text = text === '更多' ? '收起' : '更多';
              icon = text === '更多' ? 'down' : 'up'
              this.setProp({ icon, text })
            }
          });
          $tdWrapper.append(button.$el)
          $tdWrapper.parent().addClass(styles.collapse)
        }
      }
    })
  }

  private _renderConfirmButton() {
    Object.keys(this.props.data).forEach(key => {
      const { info, type } = this.props.data[key];
      if (!isObject(info) && ![EFilterType.DatePicker, EFilterType.Specification].includes(type)) {
        return;
      }

      if (isObject(info)) {
        const len = Object
          .keys(info)
          .map(ke => info[ke].type)
          .filter(ty => [EFilterType.DatePicker, EFilterType.InputRange].includes(ty))
          .length;
        if (!len) {
          return;
        }
      }

      const button = $('<div/>').OYButton({
        text: '确定',
        size: 'small',
        attrs: { class: type === EFilterType.Specification?styles.confirmButtonSpec:styles.confirmButton },
        onClick: () => this._triggerSearch()
      });
      const wrapperDiv = $('<div/>').addClass(styles.confirmButtonWrapper);
      wrapperDiv.append(button.$el);
      const $tdWrapper = this.$el.find(`#${key} .${styles.tdWrapper}`);

      if (type === EFilterType.Specification) {
        const specNode = $tdWrapper.children().get(0);
        specNode && specNode.appendChild(wrapperDiv.get(0))
      } else {
        $tdWrapper.append(wrapperDiv).addClass(styles.negative)
      }
      // .children().get(0)).append(wrapperDiv)
    })
  }

  private setLocation() {
    if (!this.props.location) {
      return;
    }
    const currentUrl = window.location.href;
    let newUrl = (currentUrl.split("?"))[0] || currentUrl;
    const params = $.extend(getFlatStringValueFilterParams(), this.getFlatParams());

    // 先拿query
    const query: any = paseQuery();
    // 根据tag里面的值。替换掉query里面的参数
    const modifyQuery = { ...query };
    (this.props.tags || [])
      .filter(({ global, key }) => global === 1 && key !== 'second_keyword')
      .reduce((que, tag) => {
        const key = tag.key.replace(/_([a-z])/g, (_m, p1) => p1.toUpperCase())
        que[key] = tag.value;
        return que;
      }, modifyQuery);

    // 删除筛选器的key
    const removeKeys = Object.keys(params).concat(this.removeLocationKeys);
    const newQuery = OYTool.objectOmit(modifyQuery, removeKeys);
    this.removeLocationKeys = [];
    // 将有效对值赋给newQuery
    $.each(params, (key, value) => {
      if (value) {
        newQuery[key] = value;
      }
    });
    if (isSameObject(query, newQuery)) {
      return;
    }

    newUrl = jointUrl(newUrl, newQuery);
    history.pushState('', '', newUrl);
  }

  /**
   *
   * @param ignoreEmpty 是否忽略空值。默认false
   * @param data 数据。有默认值。一般不需要传递
   */
  private getFlatParams(ignoreEmpty = false, data?: any) {
    const params = data || this.getStateParams(ignoreEmpty);
    let obj: any = {};
    $.each(params, (key, value) => {
      if (typeof value === 'string') {
        obj[key] = value;
      } else {
        obj = { ...obj, ...this.getFlatParams(ignoreEmpty, value) }
      }
    })
    return obj;
  }

  /**
   * 将变化的值赋给state并且emit事件
   * @param value
   * @param key
   */
  private setDataAndEmitChange(value: string[], key: string[]) {
    const data: any = {};
    key.reduce((pre, cur, curIndex) => {
      pre[cur] = curIndex === key.length - 1 ? value : {}
      return pre[cur]
    }, data)
    this.state.params = mergeDeep<any>(this.state.params, data);
    this.eventEmitter.emit(EFilterEventName.OnChange, data, this.state.params)
  }

  /**
   * 根据key value 删除params
   * @param key
   * @param value
   * @param data
  */
  private removeParamsByTagInfo(key: string, value: string, data = this.state.params) {
    Object.keys(data).forEach(dkey => {
      const dValue = data[dkey];
      if (this._isArray(dValue)) {
        if (dkey === key) {
          // 判断类型
          if (inputTypes.includes(this.state.keyTypeMap[key])) {
            data[dkey] = [];
          } else {
            const vvalue = value.split(',');
            data[dkey] = dValue.filter(va => vvalue.indexOf(va) === -1);
          }
        }
      } else if (isObject(data[dkey])) {
        this.removeParamsByTagInfo(key, value, dValue)
      }
    })
  }

  private _getValue(value: string, data: any[]) {
    let result: any;
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let index = 0; index < data.length; index++) {
      const element = data[index];
      const stringValue = `${element.value}`;
      if (stringValue && stringValue === value) {
        result = element;
        break;
      } else if (this._isArray(element.info)) {
        result = this._getValue(value, element.info);
        if (result) {
          break;
        }
      }
    }
    return result;
  }

  /**
   * 数组判断
   * @param data
   */
  private _isArray(data: string | string[] | { [i: string]: any } | { [i: string]: any }[]): data is (string | { [i: string]: any })[] {
    return isArray(data)
  }

  private _isStringArray(data: any): data is string[] {
    return isArray(data) && data.every((da: any) => typeof da === 'string');
  }

  /**
   * 判断是否是空数组
   * @param data
   */
  private _isEmptyArrary(data: string[]) {
    return !data.filter(va => !!va).length
  }

  // /**
  //  * 转换将props.value 转换成state.params,
  //  * 合并other参数
  //  * @param value
  //  * @param data
  //  */
  // private _convertValue(value: IPropsPrams, data: IParams) {
  //   const { other = {}, ...rest } = value;
  //   const params = this._convertValue2Param(rest, data);
  //   const obj: any = {};
  //   $.extend(other, (val: any, key: string) => {
  //     if (typeof val === 'string') {
  //       obj[key] = [val];
  //     } else if (isArray(val)) {
  //       obj[key] = val;
  //     }
  //   })
  //   params.other = obj;
  //   return params;
  // }

  /**
   * 将props.value 转换成state.params
   * @param value
   * @param data
   * @param parent
   * @description props.value在实际过程中可能无法保证父子级的结构。且数据value有可能是string类型
   *  需要根据state.params中的结构确定正确的位置。以及将逗号分割的字符串转为string类型的数组
   */
  private _convertValue2Param(value: IPropsPrams, data: IParams, parent: string[] = []) {
    //遍历所有筛选条件的种类
    Object.keys(data).forEach(key => {
      // let vvalue = value[key] !== undefined ? value[key] : parent.concat(key).reduce((pre, kk) => {
      //   return pre ? pre[kk] : undefined as any;
      // }, value);
      let vvalue;
      // 先从有父子级关系找
      if (parent) {
        //递归查找对应种类key的值，初始value为{}或有参数传入,选中条件时，value为筛选的条件的对象，返回对应的值
        vvalue = parent.concat(key).reduce((pre, currentKey) => {
          return pre ? pre[currentKey] : undefined as any;
        }, value);
      }
      // 找平级 ，值不存在时，vvalue为undefined
      if (!vvalue) {
        vvalue = value[key];
      }

      //判断筛选品种是普通的[]，还是有子集的对象，有子集进入递归
      const dvalue = data[key];

      // data是string | string[]。没有下级
      if (isArray(dvalue)) {
        if (dvalue.length) { // 如果有值.则忽略
          return
        }
        if (typeof vvalue === 'string') {
          // data[key] = vvalue.indexOf(',') !== -1 ? vvalue.split(',') : vvalue;
          data[key] = vvalue ? vvalue.split(',') : [];
        } else if (this._isArray(vvalue)) {
          if (this._isStringArray(vvalue)) {
            data[key] = vvalue;
          } else { // 处理老的数据
            data[key] = vvalue.map(vv => vv.value);
          }
        }
      } else if (isObject(dvalue)) {
        data[key] = this._convertValue2Param(value, dvalue as IParams, [key]);
      }
    })
    return data;
  }

  // 从props.data中提取param结构
  private _exactParamsFromData(data: { [i: string]: IDataType }) {
    const obj: IParams = {};
    Object.keys(data).forEach(key => {
      const { info, value } = data[key];
      if (isObject(info)) {
        obj[key] = this._exactParamsFromData(info);
      } else {
        obj[key] = (value && typeof value === 'string') ? value.split(',') : []; // 如果value有值.直接取value值
      }
    });
    return obj;
  }

  private _getKeyTypeMap(data: { [i: string]: IDataType }) {
    let obj: any = {};
    Object.keys(data).forEach(key => {
      const value = data[key];
      if (value.type) {
        obj[key] = value.type;
      }
      if (isObject(value.info)) {
        obj = { ...obj, ...this._getKeyTypeMap((value as any).info) };
      }
    });
    return obj;
  }

  private _getDataByKey(keys: string[], data: any = this.props.data): any {
    if (!keys.length) {
      return data;
    }

    const [key, ...others] = keys;
    if (!others.length) {
      return data[key]
    }

    const childData = data[key].info;
    if (!childData) {
      throw new Error('data info is not exist');
    }

    return this._getDataByKey(others, childData)
  }

  private _getDataAndValueByKey(keys: string[]) {
    //组合keys字符串+info中value，作为tooltip触发的节点类名
    let keysText = keys.join(',');
    const data = {...this._getDataByKey(keys),keysText};
    const value = keys.reduce((pre, cur) => pre[cur] as IParams, this.state.params)
    return { value, data }
  }

  private _triggerSearch() {
    // 更新tags
    // if (this.filterBar) {
    //   let tags = this.props.tags || [];
    //   tags = tags.concat(this.getTags())
    //   this.filterBar.setProp({ tags })
    // }
    const params = this.inputDataRangeCorrection();
    // const params = this.getParams();
    // 触发更新事件
    setTimeout(() => {
      this.eventEmitter.emit(EEventType.onSearch, params)
    });
  }

  private setKeywordAnalyseResultTags(data: string) {
    if (!data) {
      return [];
    }

    const parent = 'keywordAnalyseResult';
    const la: any[] = [];
    let lsp: any = {};
    const { rsp = [], remianText }: IKeywordAnalyseResult = JSON.parse(data);

    rsp.forEach((value, index) => {
      (value.slots || []).forEach((val, idx) => {
        if (!val.word) {
          return;
        }
        const [key1, key2] = val.type.replace(/^\[|\]$/g, '').split(":");
        if (!key2) {
          return;
        }
        const key = key2 || key1;

        const data1 = {
          key,
          value: val.word,
          title: (this.keywordAnalyseTitle[key] ? this.keywordAnalyseTitle[key] + ':' : '') + (key.indexOf("Impl") > 0 ? val.word.replace("φ", "").replace("Φ", "") : val.word) + ((val.word.toUpperCase() !== 'C' && key.indexOf("Impl") > 0 && val.word.indexOf("mm") <= 0) ? "mm" : ""),
          parent
        }
        if (this.keywordAnalyseTitleSpecial[key]) {
          lsp[key] = data1;
        } else {
          la.push(data1);
        }
      });
    })

    function dealStartEndImpl(obj: { [i: string]: any }) {
      let restObj: any = { ...obj }
      const keyMaps = [
        ['thickStartDriverImpl', 'thickEndDriverImpl', '厚度'],
        ['widthStartDriverImpl', 'widthEndDriverImpl', '宽度'],
        ['diameterStartDriverImpl', 'diameterEndDriverImpl', '厚度']
      ]

      keyMaps.forEach(([st, ed, title]) => {
        if (obj[st] && obj[ed]) {
          la.push({
            key: obj[st].key + "," + obj[ed].key,
            value: obj[st].value + "," + obj[ed].value,
            title: "厚度:" + obj[st].value + "-" + obj[ed].value + "mm",
            parent
          });
        }
        restObj = OYTool.objectOmit(restObj, [st, ed])
      })

      return restObj;
    }

    lsp = dealStartEndImpl(lsp);

    // eslint-disable-next-line guard-for-in
    for (const ma in lsp) {
      la.push(lsp[ma]);
    }

    if (remianText) {
      la.push({
        key: "remianText",
        value: remianText,
        title: remianText,
        parent
      });
    }

    return la;
  }

  private removeKeywordAnalyseResultTags(key: string, vv: string) {
    const parent = 'keywordAnalyseResult';
    const result = JSON.parse(this.state.keywordAnalyseResult);
    const newResult = { ...result, rsp: [] };
    if (result.rsp && result.rsp.length > 0) {
      newResult.rsp = result.rsp.filter((value: any, index: number) => {
        if (value.slots && value.slots.length > 0) {
          const slot = value.slots.filter((va: any, _idx: number) => {
            if (!va.word) {
              return false;
            }

            const [key1, key2] = va.type.replace(/^\[|\]$/g, '').split(":");
            const mk = key2 || key1;

            if ((key + ",").indexOf(mk + ",") > -1 && (vv + ",").indexOf(va.word + ",") > -1) {
              return false;
            }
            // if(mk == key && v.word == vv) return false;
            return true;
          });
          if (slot.length > 0) {
            value.slots = slot;
            return true;
          }
        }
        return false;
      });
    }
    if (key === 'remianText' && vv === newResult[key]) {
      newResult[key] = null;
    }
    if (newResult.rsp.length > 0 || newResult["remianText"]) {
      this.state.keywordAnalyseResult = JSON.stringify(newResult);
    } else {
      this.state.keywordAnalyseResult = '';
      this.removeLocationKeys.push('keySearch')
    }
  }

  private mergePropData(data: any) {
    Object.keys(filterData).forEach((key: any) => {
      if (data[key] !== undefined) {
        // eslint-disable-next-line no-param-reassign
        data = mergeDeep(data, { [key]: (filterData as any)[key] })
      }
    })
    return data;
  }

  private mergePropData2(target: any, source: any) {
    $.each(source, (key, item) => {
      const tItem = target[key];
      if (tItem === undefined) {
        return;
      }

      // eslint-disable-next-line no-param-reassign
      target = mergeDeep(target, { [key]: omit(item, ['info']) });

      if (item.info && tItem.info && $.isPlainObject(tItem.info)) {
        this.mergePropData2(tItem.info, item.info)
      }
    })

    return target;
  }

  // 猜你想找 点击关闭
  protected bindIconClick() {
    this.$el.find(`.${styles.guessChachaBox}`).click((ev: Event) => {
      ev.stopPropagation();
      this.$el.find(`.${styles.guessBox}`).css("display", "none")
    })
  }

  private inputDataRangeCorrection(){
    const params = this.getParams();
    if (params?.spec?.heightSpec) {
      let heightSpecParam = params.spec.heightSpec.split(",");
      if(heightSpecParam[1] != "") {
        if (parseInt(heightSpecParam[0]) > 0 && parseInt(heightSpecParam[1]) >= 0 && parseInt(heightSpecParam[0]) > parseInt(heightSpecParam[1])) {
          params.spec.heightSpec = heightSpecParam[1] + "," + heightSpecParam[0];
        }
      }
    }
    if (params?.other?.heightSpec) {
      let heightSpecParam = params.other.heightSpec.split(",");
      if(heightSpecParam[1] != "") {
        if (Number(heightSpecParam[0]) > 0 && Number(heightSpecParam[1]) >= 0 && Number(heightSpecParam[0]) > Number(heightSpecParam[1])) {
          params.other.heightSpec = heightSpecParam[1] + "," + heightSpecParam[0];
        }
      }
    }
    if (params?.spec?.widthSpec) {
      let widthSpecParam = params.spec.widthSpec.split(",");
      if(widthSpecParam[1] != "") {
        if (Number(widthSpecParam[0]) > 0 && Number(widthSpecParam[1]) >= 0 && Number(widthSpecParam[0]) > Number(widthSpecParam[1])) {
          params.spec.widthSpec = widthSpecParam[1] + "," + widthSpecParam[0];
        }
      }
    }
    if (params?.spec?.lenghtSpec) {
      let lengthSpecParam = params.spec.lenghtSpec.split(",");
      if(lengthSpecParam[1] != "") {
        if (Number(lengthSpecParam[0]) > 0 && Number(lengthSpecParam[1]) >= 0 && Number(lengthSpecParam[0]) > Number(lengthSpecParam[1])) {
          params.spec.lenghtSpec = lengthSpecParam[1] + "," + lengthSpecParam[0];
        }
      }
    }
    if (params?.balanceWeight) {
      let balanceWeightParam = params.balanceWeight.split("/");
      if(balanceWeightParam[1] != "") {
        if (Number(balanceWeightParam[0]) > 0 && Number(balanceWeightParam[1]) >= 0 && Number(balanceWeightParam[0]) > Number(balanceWeightParam[1])) {
          params.balanceWeight = balanceWeightParam[1] + "/" + balanceWeightParam[0];
        }
      }
    }
    return params;
  }


  // tooltip: { [i: string]: string } = {
  //   'service,isIntentionPayment': '该资源支持意向金支付，可选择交货期',
  //   'service,supportGoodsPhotos': '由买家向平台发起委托，仓库人员到达现场拍照上传，经审核后反馈给买家。承诺1小时内响应，3小时内可查看实物照片。',
  //   'service,isQuicklyWarehousing': '平台提供货款及运杂费一票制结算！提货方便快速，费率优惠',
  //   'service,canCompensateFlag,1': '该资源申请了售后，理赔方案一经确认，平台可先行赔付。',
  //   // 'service,quickInvoicingFlag': '该供应商到票及时，该资源享受平台闪电开票服务，于当月25日前交割完成，即可无需等待进项发票立即申请开票（供应商资质每月更新，以申请开票时供应商资质为准，敬请理解）',
  //   'service,isAfterSaleService': '该资源售后由欧冶平台受理，承诺在3个工作日内响应，理赔方案一经确认，平台可先行赔付，平均15个工作日内理赔到账',
  //   'service,hasEPD':'指环境产品声明（Environmental Product Declaration），是提供基于预设参数的量化环境数据的环境声明，必要时包括附加环境信息。'
  // }

  //将数据当中的tooltip组装为serviceTooltips对象
  private getTooltipFromService(props: any) {
    let tooltipObj = {};
    if( props.data.service && props.data.service.info){
      const { service: {info} } = props.data 
      //遍历service中的info对象
      for(let key in info){
        if( info[key].info && info[key].info.length){
          //遍历内部info数组，取出其中value，与key，service拼成一个唯一标识，作为tooltip触发节点的属性，用于查找节点
          info[key].info.forEach( (item:any) =>{
            let tooltipObjKey = 'service,' + key + ',' + item.value;
            //当tooltip字段存在时，将其合并到tooltipObj中，生成浮窗配置对象
            if(item.tooltip){
              tooltipObj = Object.assign(tooltipObj,{ [tooltipObjKey]: item.tooltip})
            }
          } )
        }
      }
    } 
    
    return tooltipObj;
  }
}



// WEBPACK FOOTER //
// ./src/components/OYFilter/index.ts